import React from 'react'
import PropTypes from 'prop-types'
import { observable } from 'mobx'
import { observer } from 'mobx-react'
import ModelContext from '../contexts/ModelContext'
import useCollection from './hooks/use-collection'
import { getMapValue, mapToObject } from '@morningtrain/react-helpers'
import debounce from 'lodash/debounce'

function CollectionEntryWhere ({ path, matches, children }) {
  const modelRef = React.useRef(observable.map())
  const model = modelRef.current

  const collection = useCollection()

  const [index, setIndex] = React.useState(null)

  React.useEffect(() => {
    if (index !== null && collection && collection[index]) {
      model.replace(mapToObject(collection[index]))
    } else {
      model.replace({})
    }
  }, [index])

  const lookForIndex = debounce((collection) => {
    if (collection) {
      collection.forEach((entry, index) => {
        if (getMapValue(entry, path) === matches) {
          setIndex(index)
        }
      })
    }
  })

  React.useEffect(() => {
    lookForIndex(collection)
  }, [path, matches])

  React.useEffect(() => {
    const disposer = collection.observe(() => {
      lookForIndex(collection)
    }, true)

    return () => {
      disposer()
    }
  }, [])

  return (
    <ModelContext.Provider value={model}>
      {children}
    </ModelContext.Provider>
  )
}

CollectionEntryWhere.propTypes = {
  path: PropTypes.string,
  matches: PropTypes.any
}

export default observer(CollectionEntryWhere)
